import { StatusesEnum } from '../../shared/enums/statuses.enum';

export const FILTER_TABS_CONFIG = [
  {
    icon: 'account_circle',
    label: 'Quotes',
    filterType: [StatusesEnum.Quoting, StatusesEnum.Enrollment],
  },
  {
    icon: 'assignment_ind',
    label: 'Enrollments',
    filterType: [StatusesEnum.Submitted, StatusesEnum.Active, StatusesEnum.Termed],
  },
  {
    icon: 'all_inbox',
    label: 'All Records',
  },
];

export const QUOTES_TABLE_COLUMNS = [
  'policyHolder',
  'group',
  'state',
  'startDate',
  'submittedDate',
  'status',
  'progress',
  'payment',
  'actions',
];

export const DEFAULT_PAGE_PARAMS = {
  PageIndex: 0,
  PageSize: 10,
  ByName: '',
  skipLoader: true,
  'SortSetting.SortedProperty': 'SubmissionDate.StartDate.Email',
  'SortSetting.SortDirection': 1,
};
